import { useAppSelector } from '@store';
import RealMonthlyVolumes from '../../../../components/common/aml/parts/real-monthly-volumes';
import { OrganizationType } from '../../types';
import { InitialCDDContentTypes } from '../types';
import InitialCDDBusiness from '../../../../components/common/aml/parts/business';

import cn from '../styles.module.css';

const InitialCDDContent = ({
  type,
  baseCurrency,
  cddFormValues,
  onChange,
  onSaveChanges,
  status,
  isDirty,
  updateRangesInProgress,
  businessPartners,
  clientScheme,
  currencies,
}: InitialCDDContentTypes) => {
  const {
    monthlyTurnover,
    numberOfIncomingTransactions,
    numberOfOutgoingTransactions,
    valueOfIncomingTransactions,
    valueOfOutgoingTransactions,
    maxValueOfIncomingPayment,
    maxValueOfOutgoingPayment,
    monthlyTurnoverCorporate,
    numberOfIncomingTransactionsCorporate,
    numberOfOutgoingTransactionsCorporate,
    valueOfIncomingTransactionsCorporate,
    valueOfOutgoingTransactionsCorporate,
    maxValueOfIncomingPaymentCorporate,
    maxValueOfOutgoingPaymentCorporate,
  } = useAppSelector((state) => state.customersDictionaries);

  return (
    <div className={cn.realMonthlyVolumeContentWrapper}>
      <RealMonthlyVolumes
        title={`Indicated monthly turnover (${baseCurrency?.name})`}
        monthlyMaxValueIncomingPaymentRangeId={
          cddFormValues?.monthlyMaxValueIncomingPaymentRangeId
        }
        monthlyMaxValueOutgoingPaymentRangeId={
          cddFormValues?.monthlyMaxValueOutgoingPaymentRangeId
        }
        monthlyNumberIncomingTransactionsRangeId={
          cddFormValues?.monthlyNumberIncomingTransactionsRangeId
        }
        monthlyNumberOutgoingTransactionsRangeId={
          cddFormValues?.monthlyNumberOutgoingTransactionsRangeId
        }
        monthlyTurnoverRangeId={cddFormValues?.monthlyTurnoverRangeId}
        monthlyValueIncomingTransactionsRangeId={
          cddFormValues?.monthlyValueIncomingTransactionsRangeId
        }
        monthlyValueOutgoingTransactionsRangeId={
          cddFormValues?.monthlyValueOutgoingTransactionsRangeId
        }
        onChange={onChange}
        onSaveChanges={onSaveChanges}
        status={status}
        saveButtonDisabled={!isDirty || updateRangesInProgress}
        requestInProgress={updateRangesInProgress}
        montlyTurnoverValues={{
          monthlyTurnover,
          numberOfIncomingTransactions,
          numberOfOutgoingTransactions,
          valueOfIncomingTransactions,
          valueOfOutgoingTransactions,
          maxValueOfIncomingPayment,
          maxValueOfOutgoingPayment,
          monthlyTurnoverCorporate,
          numberOfIncomingTransactionsCorporate,
          numberOfOutgoingTransactionsCorporate,
          valueOfIncomingTransactionsCorporate,
          valueOfOutgoingTransactionsCorporate,
          maxValueOfIncomingPaymentCorporate,
          maxValueOfOutgoingPaymentCorporate,
        }}
        corporate={Boolean(type === OrganizationType.CORPORATE)}
      />
      {type === OrganizationType.CORPORATE && (
        <InitialCDDBusiness
          businessPartners={businessPartners}
          baseCurrency={baseCurrency?.name}
          clientScheme={clientScheme}
          monthlyTurnoverCorporate={monthlyTurnoverCorporate}
          cddFormValues={cddFormValues}
          onChange={onChange}
          currencies={currencies}
        />
      )}
    </div>
  );
};

export default InitialCDDContent;
